export enum NonUKBankAccountReason {
  ACCOUNT_BEING_SET_UP = 'ACCOUNT_BEING_SET_UP',
  WAITING_FOR_BANK_DETAILS = 'WAITING_FOR_BANK_DETAILS',
  OVERSEAS_BANK_ACCOUNT = 'OVERSEAS_BANK_ACCOUNT',
  WAITING_FOR_NAME_CHANGE = 'WAITING_FOR_NAME_CHANGE',
}

export enum UKVATRegistrationReason {
  SALES_TO_UK_CUSTOMERS = 'SALES_TO_UK_CUSTOMERS',
  STORING_GOODS_IN_UK = 'STORING_GOODS_IN_UK',
  IMPORTING_GOODS = 'IMPORTING_GOODS',
  DISTANCE_SELLING = 'DISTANCE_SELLING',
  MARKETPLACE_FACILITATION = 'MARKETPLACE_FACILITATION',
  TRANSFER_OF_GOING_CONCERN = 'TRANSFER_OF_GOING_CONCERN',
  OTHER = 'OTHER',
}

export enum UKExemptSuppliesAnswer {
  YES = 'YES',
  NO = 'NO',
  NOT_SURE = 'NOT_SURE',
}

export enum UKPresenceType {
  WAREHOUSE = 'WAREHOUSE',
  REPRESENTATIVE = 'REPRESENTATIVE',
  STAFF = 'STAFF',
  NONE = 'NONE',
}
